// Types
import type { Item } from '~/constants/navigation-items';

// Utility Method
import {
    makeItem,
    makeItems,
    makeNavigationAction,
} from '~/constants/navigation-items';
import type { Locale } from '~/utils/locale';

// Jet
import {
    makeLibraryListPageIntent,
    makeLibraryPlaylistsIntent,
    makeLibraryRecentlyAddedPageIntent,
    makeLibraryTracksPageIntent,
} from '~/jet/intents';
import { LibraryListPageType } from '~/jet/models';

// Consts
import {
    ALBUMS_ID,
    ALL_PLAYLISTS_ID,
    ARTISTS_ID,
    COMPOSERS_ID,
    RECENTLY_ADDED_ID,
    RECORDINGS_ID,
    TRACKS_ID,
    WORKS_ID,
} from './tabs';

// Icons
import RecentlyAddedIcon from '~assets/icons/recently_added.svg';
import AllPlaylistIcon from '~assets/icons/navigation_all_playlists.svg';
import AlbumIcon from '~assets/icons/albums.svg';
import ArtistIcon from '~assets/icons/artists.svg';
import ComposerIcon from '~assets/icons/composers.svg';
import RecordingIcon from '~assets/icons/recordings.svg';
import TrackIcon from '~assets/icons/tracks.svg';
import WorkIcon from '~assets/icons/works.svg';

export const libraryItems: Item[] = [
    ...makeItems(
        [
            {
                id: RECENTLY_ADDED_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryRecentlyAdded.Label',
                icon: RecentlyAddedIcon,
                url: '/library/recently-added',
                makeIntent: makeLibraryRecentlyAddedPageIntent,
            },
            {
                id: ALBUMS_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryAlbums.Label',
                icon: AlbumIcon,
                url: '/library/albums',
                makeIntent: (locale: Locale): any =>
                    makeLibraryListPageIntent({
                        ...locale,
                        pageType: LibraryListPageType.Album,
                    }),
            },
            {
                id: TRACKS_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryTracks.Label',
                icon: TrackIcon,
                url: '/library/tracks',
                makeIntent: makeLibraryTracksPageIntent,
            },
            {
                id: ARTISTS_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryArtists.Label',
                icon: ArtistIcon,
                url: '/library/artists',
                makeIntent: (locale: Locale): any =>
                    makeLibraryListPageIntent({
                        ...locale,
                        pageType: LibraryListPageType.Artist,
                    }),
            },
            {
                id: RECORDINGS_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryRecordings.Label',
                icon: RecordingIcon,
                url: '/library/recordings',
                makeIntent: (locale: Locale): any =>
                    makeLibraryListPageIntent({
                        ...locale,
                        pageType: LibraryListPageType.Recording,
                    }),
            },
            {
                id: WORKS_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryWorks.Label',
                icon: WorkIcon,
                url: '/library/works',
                makeIntent: (locale: Locale): any =>
                    makeLibraryListPageIntent({
                        ...locale,
                        pageType: LibraryListPageType.Work,
                    }),
            },
            {
                id: COMPOSERS_ID,
                locKey: 'ASE.Web.MusicClassical.NavigationItems.LibraryComposers.Label',
                icon: ComposerIcon,
                url: '/library/composers',
                makeIntent: (locale: Locale): any =>
                    makeLibraryListPageIntent({
                        ...locale,
                        pageType: LibraryListPageType.Composer,
                    }),
            },
        ],
        makeNavigationAction,
    ),
];

export const allPlaylistsItem: Item = makeItem(
    {
        id: ALL_PLAYLISTS_ID,
        locKey: 'ASE.Web.MusicClassical.NavigationItems.AllPlaylists.Label',
        icon: AllPlaylistIcon,
        url: '/library/all-playlists',
        makeIntent: makeLibraryPlaylistsIntent,
    },
    makeNavigationAction,
);
